module.exports = __webpack_public_path__ + "static/media/29BDOS17.55853461.jpg";